export function getInsightSuccessCopy(action: string) {
  switch (action) {
    case "editing":
      return {
        verb: "edited",
        message: "the information of your insight.",
      };
    case "deleting":
      return {
        verb: "deleted",
        message: "the insight.",
      };
    case "deleting alert":
      return {
        verb: "deleted alert",
        message: "this alert.",
      };
    case "archiving":
      return {
        verb: "archived",
        message: "the insight.",
      };
    case "activating":
      return {
        verb: "activated",
        message: "the insight.",
      };
    case "sharing":
      return {
        verb: "shared",
        message: "the insight.",
      };
    case "unsharing":
      return {
        verb: "unshared",
        message: "the insight.",
      };
    default:
      return {
        verb: action,
        message: "the insight.",
      };
  }
}
